// dependency-graph-ignore-file
import { createContextMenuEffect } from '@databases/context-menu/context-menu-effect';
import { getCachedViewSnapshotForSelections } from '@databases/database-state';
import { type DatabaseAdapter } from '@databases/selections-api-types';
import { getService } from '@databases/service-container';

import { waitForContentAPI } from '@canvas/frame-api/host-api/host-frame-context';

import {
  type SelectionEffectFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

export function createContextMenuEffectFeature(deps: {
  contentId: string;
  databaseAdapter: DatabaseAdapter;
}): SelectionEffectFeature {
  let isDBAiFirstCreationEnabled = false;

  void waitForContentAPI().then((contentAPI) => {
    isDBAiFirstCreationEnabled =
      contentAPI.confluenceAPI?.shell?.isFeatureActive?.('dbAiFirstCreation') ?? false;
  });

  return {
    key: SelectionFeatureKeys.CONTEXT_MENU_EFFECT,
    type: 'effect',
    factory: () =>
      createContextMenuEffect({
        selectionsApi: getService('SelectionsApi'),
        databaseAdapter: deps.databaseAdapter,
        contentId: deps.contentId,
        currentViewId: getCachedViewSnapshotForSelections().id,
        formatMessage: getService('Intl').formatMessage,
        panelManager: getService('PanelManager'),
        selectionsActions: getService('SelectionsActions'),
        highlightsController: getService('TableHighlightsController'),
        selectionsReader: getService('SelectionsReader'),
        getIsDBAiFirstCreationEnabled: () => isDBAiFirstCreationEnabled,
      }),
  };
}
